import { Route, Switch } from 'react-router';
import React from 'react';
import { connect } from 'react-redux';

import Links from '../data/Links';
import ProtectedRoute from './ProtectedRoute';
import Login from '../views/Login';
import User from '../views/User';
import Vehicle from '../views/Vehicle';
import VehicleUtil from '../views/VehicleUtil';
import VehicleAd from '../views/VehicleAd';
import UpcomingCars from '../views/UpcomingCars';
import MetaData from '../views/MetaData';
import BankForms from '../views/BankForms';
import SliderImage from '../views/SliderImage';
import Suggestion from '../views/Suggestion';
import Packages from '../views/Packages';
import Services from '../views/Services';
import Analytics from '../views/Analytics';
import Order from '../views/Order';
import Leads from '../views/Leads';
import InspectionOrder from '../views/InspectionOrder';
import Calender from '../views/Calender';
import Banner from '../views/Banner';
import Tags from '../views/Tags';
import UserLevels from '../views/UserLevels';

const _404 = React.lazy(() => import('../views/404'));
const Dashboard = React.lazy(() => import('../views/Dashboard'));

const Routes = ({ auth, user }) => (
	<Switch>
		<ProtectedRoute path={Links.DASHBOARD} exact component={Dashboard} auth={auth} />
		<ProtectedRoute path={Links.VEHICLE_AD} exact component={VehicleAd} auth={auth} />
		<ProtectedRoute path={Links.UPCOMING_CARS} exact component={UpcomingCars} auth={auth} />
		<ProtectedRoute path={Links.VEHICLE} exact component={Vehicle} auth={auth} />
		<ProtectedRoute path={Links.UTIL} exact component={VehicleUtil} auth={auth} />
		<ProtectedRoute path={Links.ANALYTICS} exact component={Analytics} auth={auth} />
		<ProtectedRoute path={Links.LEADS} exact component={Leads} auth={auth} />
		<ProtectedRoute path={Links.TAGS} exact component={Tags} auth={auth} />
		<ProtectedRoute path={Links.USERLEVELS} exact component={UserLevels} auth={auth} />

		{user?.role === 'superAdmin' && (
			<>
				<ProtectedRoute path={Links.USER} exact component={User} auth={auth} />
				<ProtectedRoute path={Links.META_DATA} exact component={MetaData} auth={auth} />
				<ProtectedRoute path={Links.BANK_FORMS} exact component={BankForms} auth={auth} />
				<ProtectedRoute path={Links.SLIDER_IMAGE} exact component={SliderImage} auth={auth} />
				<ProtectedRoute path={Links.BANNER} exact component={Banner} auth={auth} />
				<ProtectedRoute path={Links.SUGGESTION} exact component={Suggestion} auth={auth} />
				<ProtectedRoute path={Links.PACKAGES} exact component={Packages} auth={auth} />
				<ProtectedRoute path={Links.SERVICES} exact component={Services} auth={auth} />
				<ProtectedRoute path={Links.ORDERS} exact component={Order} auth={auth} />
				<ProtectedRoute path={Links.INSPECTION_ORDERS} exact component={InspectionOrder} auth={auth} />
				<ProtectedRoute path={Links.CALENDER} exact component={Calender} auth={auth} />
			</>
		)}
		<Route exact path={Links.LOGIN} component={Login} />
		<Route component={_404} />
	</Switch>
);

const mapStateToProps = (state) => ({
	user: state.session.user,
});

export default connect(mapStateToProps)(Routes);
